import { createContext, useState } from "react";

export const ProveedorContext = createContext();

const ProveedorProvider = ({ children }) => {
    const [cuit, setCuit] = useState();
	const [cuitAutorizado, setCuitAutorizado] = useState(false);

    const onRegistrarAccesoProveedor = (cuit,isCuitAutorizado) => {
        setCuit(cuit);
        setCuitAutorizado(isCuitAutorizado);
    };

    return (
        <ProveedorContext.Provider value={{ cuit, cuitAutorizado, onRegistrarAccesoProveedor }}>
            {children}
        </ProveedorContext.Provider>
    );
};

export default ProveedorProvider;
